module.exports = __webpack_public_path__ + "assets/img/title-2079288c.png";